export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar cheque electrónico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta de crédito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de activación"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])}
}